import Vue from 'vue'
import { Store } from 'vuex'

export class ComponentMounter {
    public static mount(componentType: any, parentElement: Element, propsData: any, store: Store<any>) {
        const ExtendedClass = Vue.extend(componentType)
        const instance = new ExtendedClass({
            propsData,
            store,
            beforeDestroy: () => {
                parentElement.removeChild(instance.$el)
            }
        })

        instance.$mount() // pass nothing
        parentElement.appendChild(instance.$el)

        return instance
    }
}
